import React from "react";

export default function BenefitsOfJoining() {
  return (
    <div id="preSaleDetails" className="w-full flex flex-col py-16 md:pb-20 items-center text-sky-800 dark:text-white ">
      <div className="grid md:gap-10 md:grid-cols-discover w-10/12 lg:w-9/12">
        <div>
          <p className="text-sm border-b pb-2 font-medium border-sky-800 dark:border-gray-100 mt-4 dark:text-sky-500">
            WHERE WE GROW
          </p>
        </div>
        <div className="md:p-2 mt-5 md:mt-0">
          <h1 className="text-4xl font-bold">
            Benefits of joining{" "}
            <span className="dark:text-sky-500">GDSC UIT</span>
          </h1>
          <p className="mt-3 text-gray-500 dark:text-gray-400">
          ⚡GDSC-UIT empowers all the students to not only build solutions for the community but to overcome their technical barriers too by Connecting, Learning, and Growing together.
          </p>
          <br />
          <p>
          Join us and let's take this <span className="dark: text-sky-500 font-bold text-lg">community to new heights !</span>
          </p>
        </div>
      </div>
      <div className="w-10/12 lg:w-9/12 grid gap-7 md:grid-cols-5 mt-10">
        <div>
          <div className="bg-sky-800 text-white flex items-center justify-center dark:bg-sky-500 w-16 h-16 rounded-full">
            01
          </div>
          <div className="bg-gray-100 shadow-xl shadow-sky-500/30 dark:bg-content bg-center bg-cover p-5 mt-5 rounded-lg">
            <h1 className="text-lg font-bold">Community building</h1>
    
          </div>
        </div>
        <div>
          <Step
            number="02"
            title="Global community"
        
          />
        </div>
        <div>
          <Step
            number="03"
            title="Technical knowledge"
      
          />
        </div>
        <div>
          <Step number="04" title="Swags and benefits"  />
        </div>
        <div>
          <Step number="05" title="Global opportunites" />
        </div>
      </div>
    </div>
  );
}

function Step({ number, title, supply, price }) {
  return (
    <>
      <div className="bg-sky-800 text-white flex items-center justify-center dark:bg-sky-500 w-16 h-16 rounded-full">
        {number}
      </div>
      <div className="bg-gray-100 dark:bg-content bg-center bg-cover p-5 mt-5 rounded-lg">
        <h1 className="text-lg font-bold">{title}</h1>

      </div>
    </>
  );
}
